import React from "react";
import H4 from "./Typography/H4";
import Icon from "./Icon";
import Button from "./Button";

interface ModalProps extends ModalActionsProps {
  status: boolean;
  heading?: string | React.ReactElement;
  children?: any;
  size?: "small" | "medium" | "large";
}

type ModalActionsProps = {
  onSubmit?: any;
  onClose: any;
};

const Modal: React.FC<ModalProps> = ({
  status,
  heading,
  children,
  onSubmit,
  onClose,
  size,
}): React.ReactElement | null => {
  const closeOnlyIfItsParent = (e: any) => {
    if (e.target.id === "modal-parent") {
      onClose();
    }
  };

  return status ? (
    <div
      id="modal-parent"
      className="flex items-center justify-center absolute top-0 left-0 w-full h-screen bg-[#d4d4d4bd] z-10"
      onClick={closeOnlyIfItsParent}
    >
      <div
        className={`flex flex-col ${
          size === "small"
            ? "md:w-3/12"
            : size === "medium"
            ? "md:w-6/12"
            : size === "large"
            ? "md:w-10/12"
            : "md:w-3/12"
        } w-10/12 max-h-1/2 bg-white shadow-lg rounded-md p-5`}
      >
        <div
          className={`flex w-full ${
            heading ? "justify-between" : "justify-end"
          }  items-center`}
        >
          {heading ? <H4>{heading}</H4> : null}
          <Icon name="Close" onClick={onClose} className="cursor-pointer" />
        </div>
        <div className="content flex flex-col w-full h-full overflow-scroll items-center">
          {children}
        </div>
        <ModalActions onSubmit={onSubmit} onClose={onClose} />
      </div>
    </div>
  ) : null;
};

export const ModalActions: React.FC<ModalActionsProps> = ({
  onSubmit,
  onClose,
}): React.ReactElement => {
  return (
    <div className="flex w-full items-end justify-end gap-2 text-white py-2">
      {onSubmit ? (
        <Button variant="primary" id="submitBtn" onClick={onSubmit}>
          Submit
        </Button>
      ) : null}
      <Button variant="neutral" id="closeBtn" onClick={onClose}>
        Close
      </Button>
    </div>
  );
};

export default Modal;
